// ═══════════════════════════════════════════════════════════════════════════
// Catálogos del SAT
//
// Extraídos literal de index.html v0.9.16 (líneas 248-297 y 627).
// Sin cambios: son datos normativos.
// ═══════════════════════════════════════════════════════════════════════════

export const SAT_REGIMEN_FISCAL = [
  { code: "601", label: "General de Ley Personas Morales", type: "moral" },
  { code: "603", label: "Personas Morales con Fines no Lucrativos", type: "moral" },
  { code: "605", label: "Sueldos y Salarios e Ingresos Asimilados", type: "fisica" },
  { code: "606", label: "Arrendamiento", type: "fisica" },
  { code: "607", label: "Régimen de Enajenación o Adquisición de Bienes", type: "fisica" },
  { code: "608", label: "Demás ingresos", type: "fisica" },
  { code: "610", label: "Residentes en el Extranjero sin EP", type: "both" },
  { code: "611", label: "Ingresos por Dividendos", type: "fisica" },
  { code: "612", label: "Personas Físicas con Actividades Empresariales y Profesionales", type: "fisica" },
  { code: "614", label: "Ingresos por intereses", type: "fisica" },
  { code: "616", label: "Sin obligaciones fiscales", type: "both" },
  { code: "620", label: "Sociedades Cooperativas de Producción", type: "moral" },
  { code: "621", label: "Incorporación Fiscal", type: "fisica" },
  { code: "622", label: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras", type: "both" },
  { code: "623", label: "Opcional para Grupos de Sociedades", type: "moral" },
  { code: "624", label: "Coordinados", type: "moral" },
  { code: "625", label: "Actividades Empresariales con Plataformas Tecnológicas", type: "fisica" },
  { code: "626", label: "Régimen Simplificado de Confianza", type: "both" },
];

export const SAT_FORMA_PAGO = [
  { code: "01", label: "Efectivo" },
  { code: "02", label: "Cheque nominativo" },
  { code: "03", label: "Transferencia electrónica de fondos" },
  { code: "04", label: "Tarjeta de crédito" },
  { code: "06", label: "Dinero electrónico" },
  { code: "28", label: "Tarjeta de débito" },
  { code: "99", label: "Por definir" },
];

export const SAT_METODO_PAGO = [
  { code: "PUE", label: "Pago en una sola exhibición" },
  { code: "PPD", label: "Pago en parcialidades o diferido" },
];

export const SAT_USO_CFDI = [
  { code: "G01", label: "Adquisición de mercancias" },
  { code: "G03", label: "Gastos en general" },
  { code: "I01", label: "Construcciones" },
  { code: "I08", label: "Otra maquinaria y equipo" },
  { code: "D01", label: "Honorarios médicos, dentales y hospitalarios" },
  { code: "D04", label: "Donativos" },
  { code: "P01", label: "Por definir" },
  { code: "S01", label: "Sin efectos fiscales" },
];

export const SAT_MOTIVOS_CANCELACION = [
  { code: "01", label: "Comprobante emitido con errores con relación", needsSubstitute: true },
  { code: "02", label: "Comprobante emitido con errores sin relación", needsSubstitute: false },
  { code: "03", label: "No se llevó a cabo la operación", needsSubstitute: false },
  { code: "04", label: "Operación nominativa relacionada en factura global", needsSubstitute: false },
];

// Claves por omisión. En el modelo nuevo cada producto trae las suyas
// (product.sat_product_key / sat_unit_key): servicios enológicos, asesoría y
// TI usan claves distintas a las del vino.
export const SAT_PRODUCT_KEY_WINE = "50202301";  // Vino
export const SAT_UNIT_KEY_BOTTLE  = "H87";       // Pieza
